import { BoostLocation } from "../redux-magic/sub-interfaces/sub-interfaces";

const CalculateMinBoostBudget: Function = (
	locations: Array<BoostLocation>,
	duration_in_hours: number,
	auto_surge_multiplier: number = 1,
	manual_surge_multiplier: number = 1,
) => {
	const POINTS_PER_KM_FOR_FIRST_5_KM_PER_HOUR = 16 / 4 / 7 / 24; // 0.0238 Beegru Points
	const EXTRA_POINTS_PER_KM_ABOVE_5_KM_PER_HOUR = 8 / 4 / 7 / 24; // 0.0119 Beegru Points

	let total_points_per_hour = 0;

	// Calculate the total points for each location
	// and sum them up to get the total points per hour
	// for all locations
	locations.forEach((location: BoostLocation) => {
		const { radius } = location;
		const base_km = Math.min(radius, 5);
		const extra_km = Math.max(radius - 5, 0);

		const base_points = base_km * POINTS_PER_KM_FOR_FIRST_5_KM_PER_HOUR;
		const extra_points = extra_km * EXTRA_POINTS_PER_KM_ABOVE_5_KM_PER_HOUR;
		const total_points_for_location_per_hour = base_points + extra_points;
		const total_points_for_location = total_points_for_location_per_hour * duration_in_hours;
		total_points_per_hour += total_points_for_location;
	});

	// Calculate the total points per hour
	// for all locations and multiply it by the surge multipliers
	// to get the total points with surge
	// and round it up to the nearest integer

	//TODO: Select one surge multiplier, manual if it's activated, otherwise auto
	const surge_multiplier = auto_surge_multiplier * manual_surge_multiplier;

	const total_points_with_surge = Math.ceil(total_points_per_hour * surge_multiplier);

	return total_points_with_surge;
};

export default CalculateMinBoostBudget;
